import { z } from "zod";

export interface AccountListEntity {
  nroCuenta: string;
  zonaComercial: string;
  localidad: string;
  razonSocial: string;
  tipoDeCuenta: string;
  controlDeSaldos: boolean;
}

export interface AccountData {
  id: number;
  cuenta: string;
  razonSocial: string;
  tipoCuenta: string;
  categoriaCuenta: string;
  localidad: string;
  zonaComercial: string;
  condicionFinanciera: string;
  saldos: Balance;
  estado: string;
  personas: AccountPerson[];
  cbus: AccountCBU[];
  usuarios: AccountUsuarioMobile[];
  acuerdoCredito: AccountCreditAgreement;
}

interface Balance {
  aVencer: number;
  aVencerAdmis: number;
  total: number;
  totalAdmis: number;
  vencido: number;
  vencidoAdmis: number;
}

export interface AccountPerson {
  nombre: string;
  apellido: string;
  documento: number;
}

export interface AccountCBU {
  cbu: string;
  banco: string;
  tipoCta: string;
}

export interface AccountUsuarioMobile {
  email: string;
  nombre: string;
  apellido: string;
}

export interface AccountCreditAgreement {
  creditoVencido: number;
  creditoTotal: number;
}

export const accountFilterSchema = z.object({
  social_reason: z.any().optional(),
  locality: z.any().optional(),
  balance_control: z.any().optional(),
  account_number: z.any().optional(),
  account_type: z.any().optional(),
  commercial_zone: z.any().optional(),
});
